import React, { useState } from 'react';
import { X } from 'lucide-react';

let setGlobalImage = null;

export const ImageViewer = () => {
  const [src, setSrc] = useState(null);
  setGlobalImage = setSrc;

  if (!src) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 cursor-zoom-out" onClick={() => setSrc(null)}>
      <button className="absolute top-4 right-4 text-white hover:text-red-400 z-10" onClick={() => setSrc(null)}><X className="w-8 h-8" /></button>
      <img src={src} alt="" className="max-w-[95vw] max-h-[95vh] object-contain rounded-lg shadow-2xl" onClick={e => e.stopPropagation()} />
    </div>
  );
};

export const initImageViewer = () => {
  document.addEventListener('dblclick', (e) => {
    const img = e.target.closest('img');
    if (img && img.src && setGlobalImage) {
      e.preventDefault();
      setGlobalImage(img.src);
    }
  });
};
